/**
 * Comes back off the shoulder somewhere new each time. The pattern is a rumour.
 */

import type { Affix } from '@/sim/items/affixContract';

export const WILD_RETURN = {
  id: 'wildReturn',
  slot: 'suffix',
  field: 'recoil',
  direction: 1,
  label: 'Increased recoil',
  nameWord: 'of the Wild Return',
  ranges: {
    common: { min: 0.06, max: 0.11 },
    uncommon: { min: 0.11, max: 0.18 },
    rare: { min: 0.18, max: 0.27 },
    exotic: { min: 0.27, max: 0.4 },
  },
} as const satisfies Affix;
